import { useFetch } from "hooks/api";
import Accordion from "components/core/basic/Accordion";

import { useAppSelector } from "redux/hooks";
import Card from "components/core/basic/Card";
import DSPProfilesTable from "./DSPProfilesTable";
import { useRef } from "react";
import useOnScreen from "hooks/useOnScreen";

const DSPProfileSummary = () => {
  const user = useAppSelector((state) => state.user);
  const { marketPlace } = useAppSelector((state) => state.marketPlace);

  const dspProfileSectionRef = useRef();
  const isDSPProfileSectionVisible = useOnScreen(dspProfileSectionRef);

  const { data: dspProfileData, isLoading: isDSPProfileDataLoading } = useFetch(
    ["dspProfiles", marketPlace],
    "/api/dsp/profiles/",
    {
      include_associations: true,
      marketplace: marketPlace,
    },
    {
      select: (d) => d.data,
      default: [],
      enabled: user.is_staff && isDSPProfileSectionVisible,
      staleTime: 30 * 60 * 1000,
    },
  );

  return (
    <Accordion title={"DSP Profiles"}>
      <Card ref={dspProfileSectionRef}>
        <DSPProfilesTable
          tableData={dspProfileData?.data}
          columnsToRender={[
            "dsp_advertiser_id",
            "dsp_client_account_id",
            "dsp_client_name",
            "country",
            "onboarded",
            "url",
            "onboarded_org_id",
            "suggested_org_id",
            "actions",
          ]}
          isLoading={isDSPProfileDataLoading}
          isSelectable={false}
          defaultSorted={[{ id: "name", desc: true }]}
        />
      </Card>
    </Accordion>
  );
};

export default DSPProfileSummary;
